<!-- <ng-template #loadingTemplate>
    <div>Calculating...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<div [hidden]="!loading" class="page-overlay" style="z-index: 9999;">
    <div class="page-overlay-content" style="z-index: 9999;">
        <div *ngIf="loading; then loadingTemplate"></div>
    </div>
</div> -->

<ng-template #loadingTemplate>
    <div class="loading-container">
        <div class="logo-wrapper">
            <div class="spinning-border"></div>
            <div class="logo-container">
                <img
                    [src]="logoPath"
                    alt="eFACT Loading"
                    class="efact-logo pulse-animation">
            </div>
        </div>
        <div class="loading-text">Calculating...</div>
    </div>
</ng-template>
<div [hidden]="!loading" class="page-overlay" style="z-index: 9999; height: 100vh; width: 100vw;">
    <div class="page-overlay-content" style="z-index: 9999; justify-content: center;">
        <div *ngIf="loading; then loadingTemplate"></div>
    </div>
</div>

<div class="card" id="card">
    <p-toolbar>
        <p-floatLabel variant="on">
            <p-select [options]="fyeSelectItem" appendTo="body" [autoDisplayFirst]="false"
                (onChange)="fyeChanged($event)" [(ngModel)]="selectedFYE">
            </p-select>
            <label for="float-dd">Fiscal Year End</label>
        </p-floatLabel>

        <button pButton pRipple type="button" severity="secondary" icon="pi pi-calculator" label="Calculate Rates" (click)="calcRates()"></button>
    </p-toolbar>

    <p-accordion [multiple]="true">

        <p-accordionTab [selected]="true" id="bwtab" header="Budget Worksheet">
            <p-table stripedRows *ngIf="budgetWorksheetData && budgetWorksheetData.length > 0" [columns]="dynamicBWColumns" [value]="budgetWorksheetData" [rowTrackBy]="trackBudgetWorksheetRow" [scrollable]="true" scrollHeight="50vh" [tableStyle]="{ 'min-width': '100%' }">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pFrozenColumn [frozen]="IsColumnFrozen">
                            Cost Center
                            <p-columnFilter field="CCID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect [hidden]="this.multipleCC == false" id="cc_dd" defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
                                        appendTo="body" [options]="costCentersSelectItem"
                                        (onChange)="filter($event.value)" [(ngModel)]="selectedCCDescFilterValue">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th pFrozenColumn [frozen]="IsColumnFrozen">
                            Cost Type
                            <p-columnFilter field="CostTypeGroup" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect id="ct_dd" defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
                                        appendTo="body" [options]="costTypesSelectItem"
                                        (onChange)="filter($event.value)" [(ngModel)]="selectedCostTypeFilterValue">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th *ngFor="let col of columns">
                            {{ col.header }} Budget
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing">
                    <tr>
                        <td pFrozenColumn [frozen]="IsColumnFrozen">
                            {{ rowData.CCDesc }}
                        </td>
                        <td pFrozenColumn [frozen]="IsColumnFrozen">
                            {{ rowData.CostType }}
                        </td>
                        <td *ngFor="let line of rowData.Line; let i = index; trackBy: trackBudgetWorksheetLine" [pEditableColumn]="line.Budget" pEditableColumnField="Budget">
                            <!-- <input pInputText [(ngModel)]="line.Budget" (blur)="updateRatePlanningTable(rowData, i)"/> -->
                            <input
                            pInputText
                            [(ngModel)]="line.Budget"
                            [attr.data-budget-cell]="getBudgetCellKey(rowData, i)"
                            (focus)="onBudgetCellFocus(rowData, i)"
                            (blur)="onBudgetCellBlur($event, rowData, i)"
                            (keydown.enter)="onBudgetCellEnter($event, rowData, i)" />
                            <!-- <p-cellEditor>
                                <ng-template #input>
                                    <input pInputText [(ngModel)]="line.Budget" (blur)="updateRatePlanningTable(rowData, i)"/>
                                </ng-template>
                                <ng-template #output>
                                    {{ line.Budget }}
                                </ng-template>
                            </p-cellEditor> -->
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <!-- <div id="rate-planning"></div> -->
        </p-accordionTab>

        <p-accordionTab [selected]="true" id="ratestab" header="Indirect Rates">
            <p-table stripedRows *ngIf="ratesData && ratesData.length > 0" [columns]="dynamicBWColumns" [value]="ratesData" [scrollable]="true" scrollHeight="50vh" [tableStyle]="{ 'min-width': '100%' }">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pFrozenColumn [frozen]="IsColumnFrozen">
                            Cost Center
                            <p-columnFilter field="CCID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect [hidden]="this.multipleCC == false || this.ratesData == null || this.ratesData.length == 0" id="rate_cc_dd" defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
                                        appendTo="body" [options]="ratesCostCentersSelectItem"
                                        (onChange)="filter($event.value)" [(ngModel)]="selectedRatesCCDescFilterValue">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th pFrozenColumn [frozen]="IsColumnFrozen">
                            Cost Type
                            <p-columnFilter field="CostTypeGroup" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect [hidden]="this.ratesData == null || this.ratesData.length == 0" id="rate_ct_dd"  defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
                                        appendTo="body" [options]="ratesCostTypesSelectItem"
                                        (onChange)="filter($event.value)" [(ngModel)]="selectedRatesCostTypeFilterValue">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th *ngFor="let col of columns">
                            {{ col.header }} Budget
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing">
                    <tr>
                        <td pFrozenColumn [frozen]="IsColumnFrozen">
                            {{ rowData.CCDesc }}
                        </td>
                        <td pFrozenColumn [frozen]="IsColumnFrozen">
                            {{ rowData.CostType }}
                        </td>
                        <td *ngFor="let col of columns; let i = index" [pEditableColumn]="col.Budget" pEditableColumnField="Budget">
                            {{ rowData.Line[i].Budget }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <!-- <div id="rates"></div> -->
             <span *ngIf="ratesData && ratesData.length == 0" class="flex justify-content-center">
                No Indirect Rates calculated for the selected Fiscal Year End.
             </span>
        </p-accordionTab>

    </p-accordion>

    <!-- <p-multiSelect [hidden]="this.multipleCC == false" id="cc_dd" defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
        appendTo="body" [options]="costCentersSelectItem" [filter]="true" [virtualScroll]="true" itemSize="30"
        (onChange)="filterTable($event, 'CCDesc')" [(ngModel)]="selectedCCDescFilterValue">
    </p-multiSelect>
    <p-multiSelect id="ct_dd" defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
        appendTo="body" [options]="costTypesSelectItem" [filter]="true" [virtualScroll]="true" itemSize="30"
        (onChange)="filterTable($event, 'CostType')" [(ngModel)]="selectedCostTypeFilterValue">
    </p-multiSelect> -->

    <!-- <p-multiSelect [hidden]="this.multipleCC == false || this.ratesData == null || this.ratesData.length == 0" id="rate_cc_dd" defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
        appendTo="body" [options]="ratesCostCentersSelectItem" [filter]="true" [virtualScroll]="true" itemSize="30"
        (onChange)="filterRatesTable($event, 'CCDesc')" [(ngModel)]="selectedRatesCCDescFilterValue">
    </p-multiSelect>
    <p-multiSelect [hidden]="this.ratesData == null || this.ratesData.length == 0" id="rate_ct_dd"  defaultLabel="Filter" maxSelectedLabels="1" selectedItemsLabel="{0} items selected."
        appendTo="body" [options]="ratesCostTypesSelectItem" [filter]="true" [virtualScroll]="true" itemSize="30"
        (onChange)="filterRatesTable($event, 'CostType')" [(ngModel)]="selectedRatesCostTypeFilterValue">
    </p-multiSelect> -->
</div>
